exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GridFiller-module__wrapper___2SwVu{height:100%;width:.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "GridFiller-module__wrapper___2SwVu"
};